/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-alert */
import React, { useState, useEffect } from 'react';
import { FasHistory } from 'assets/icons';
import {
  onEnterKeyPress, showSuccessNotification, showErrorNotification
} from 'helpers';
import bindLogger from 'helpers/BindLogger';
import CommunicationMethod from 'components/EmailGenerator/CommunicationMethod';
import { openConfirmation } from 'components/Confirmation/Confirmation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withAppContext } from '@ctsu/loader';

import {
  togglePacketLockBtn,
  getIndexing,
  getPacketStatusHistory,
  saveAdditionalDetails,
  saveComments,
  copyPacket,
  toggleAdditionalDetails,
  saveEventHistory,
  updateIndexing,
  deleteIndexing,
  getPacketCommunication
} from 'actions/packet';
import { RenderElement } from 'components/RenderHelpers';
import {
  CanUserViewDetails,
  CanUserEditDetails,
  CanUserEditPacketComments,
  CanUserSeePacketHistory,
  CanUserSeePacketStatus
} from 'appconstants/Permission';
import _ from 'lodash';
import { ATCONSTANTS as ATC } from 'appconstants';
import PacketIButton from 'components/iButton/PacketIButton';
import PersonIButton from 'components/iButton/PersonIButton';
import TrackingCodeStatus from './TrackingCodeStatus';
import DetailsHeader from './DetailsHeader';
import PacketCommunication from './PacketCommuication';
import EditAdditionalDetails from './EditAdditionalDetails';
import SupportingDocs from './SupportingDocs';
import ExternalComment from './ExternalComment';
import { setIndexingData } from './AddditinalDetailsUtils';
import PacketCopyPaste from './PacketCopyPaste';

function DeatailsSubHeader({ title, children, id }) {
  return (
    <div className="form-sub-group-label">
      <div
        data-id={`${ATC.PACKETID}${id}_${title
          .split(' ')
          .join('_')
          .toUpperCase()}_TITLE${ATC.DIV}`}
        className={`form-layout-title mb-2 ${children && 'col-5'}`}
        role="heading"
        aria-level="4"
      >
        {title}
      </div>
      {children && <div className="col-7 mb-2">{children}</div>}
    </div>
  );
}

function LinkButton({
  title, onClick, name
}) {
  const onKeyDown = e => onEnterKeyPress(e, onClick);
  return (
    <button
      type="button"
      onKeyDown={onKeyDown}
      onClick={onClick}
      className="btn turquoise mx-1 whiteSpace-nowrap"
      title={title}
    >
      {name}
    </button>
  );
}

const copyPasteFiledsFn = (packetId) => <PacketCopyPaste packetId={packetId} />;

const trackingCodeStatusColumns = [
  { name: 'object', label: 'Content' },
  {
    name: 'packetId',
    label: 'Packet ID',
    renderCell: ({ id, packetId }) => (
      <>
        <PacketIButton packetDbId={id} packetId={packetId} />
        <span>{packetId}</span>
      </>
    )
  },
  { name: 'status', label: 'Status' },
  { name: 'trackingCodeStatusDate', label: 'Date' }
];

const packetStatusHistoryColumns = [
  { name: 'createdBy', label: 'Created By' },
  { name: 'status', label: 'Status' },
  { name: 'statusDt', label: 'Date' },
  { name: 'followupReason', label: 'Follow Up Reason' }
];

let modal;

const communicatePacket = (reasonCheck, rqStatus, extraProps) => {
  const {
    controller, editedDetails, packetId, appliedFilters, saveHandler, closeComModal, cancelModel
  } = extraProps;
  modal = openConfirmation({
    header: 'Communicate - PACKET',
    isClose: false,
    fullscreen: 'Modal-fullscreen',
    closeHandler: cancelModel,
    renderComp: () => (
      <CommunicationMethod
        saveCommunicationHanlder={saveHandler}
        cancelCommunicationHanlder={closeComModal}
        keyValue={rqStatus}
        controller={controller}
        appliedFilters={appliedFilters}
        showReason={reasonCheck}
        dbId={packetId}
        tagName="PACKET_EMAIL_"
        orgType="PACKET_SCREENS"
        additionalDetails={editedDetails}
        CopyPasteFields={() => copyPasteFiledsFn(packetId)}
      />
    )
  });
};

const onClicktrackingCodeStatus = (trackingCodeStatus, id) => {
  const trackingCodeDataOrder = [...trackingCodeStatus];
  trackingCodeDataOrder.sort(
    (a, b) => new Date(a.trackingCodeStatusDate) - new Date(b.trackingCodeStatusDate)
  );
  openConfirmation({
    header: 'Tracking Code Status',
    isClose: true,
    renderComp: () => (
      <TrackingCodeStatus
        id={id}
        showTrackingCode
        data={trackingCodeDataOrder}
        columns={trackingCodeStatusColumns}
      />
    )
  });
};

const getPacketHistory = (attr, onClickPacketHistory) => (attr === 'status' && CanUserSeePacketHistory() ? (
  <button
    type="button"
    data-id={`${ATC.PACKETID}PACKET_TYPE_HISTORY${ATC.BUTTON}`}
    className="fn-btn font-lg ml-2"
    title="Packet Status History"
    onClick={() => onClickPacketHistory()}
  >
    <FasHistory />
  </button>
) : null);

const getTrackingCodeCmp = (attr, trackingCodeStatus, id) => (attr === 'trackingBarCode' && CanUserSeePacketStatus() ? (
  <LinkButton onClick={() => onClicktrackingCodeStatus(trackingCodeStatus, id)} title="Tracking Bar Code Status" name="Status" />
) : null);

const getStatusCmp = (attr, onClickPacketHistory) => (attr === 'status' ? (
  <div>
    <button
      type="button"
      data-id={`${ATC.PACKETID}PACKET_TYPE_HISTORY${ATC.BUTTON}`}
      className="fn-btn font-lg ml-2"
      title="Packet Status History"
      onClick={() => onClickPacketHistory()}
    >
      <FasHistory />
    </button>
  </div>
) : null);

const getContactCmp = (attr, packet) => (
  attr === 'contact' && packet.contact !== null ? (
    <>
      &nbsp; (
      {packet.contactCtepId}
      ) &nbsp;
      <PersonIButton personCtepId={packet.contactCtepId} />
    </>
  ) : null
);

const getValueCmps = (value, children) => (value != null ? children : null);

const getLinkButton = () => (CanUserSeePacketStatus() ? LinkButton : null);

const getReqCls = (attr) => (attr === 'contact' ? '' : 'row col-12 flex-nowrap');

const getAdditionalDetailsEditCmp = (inputProps, label, attr) => {
  const {
    packet,
    context,
    metaData,
    indexingRows,
    takeComm,
    editedDetails,
    setEditedDetails,
    setIsObjectDirty,
    selectedLabel,
    setSelectedLabel,
    trackingCodeStatus,
    controller,
    appliedFilters,
    cancelModel,
    saveHandler,
    closeComModal
  } = inputProps;
  const { id } = packet;
  return (attr === 'trackingBarCode' ? (
    <EditAdditionalDetails
      selectedLabel={selectedLabel}
      setSelectedLabel={setSelectedLabel}
      label={label}
      att={packet[attr]}
      attr={attr}
      metaData={metaData}
      indexingRows={indexingRows}
      setIsObjectDirty={setIsObjectDirty}
      context={context}
      data={editedDetails}
      setData={setEditedDetails}
      onClicktrackingCodeStatus={() => onClicktrackingCodeStatus(trackingCodeStatus, id)}
      LinkButton={getLinkButton()}
      takeComm={takeComm}
    />
  ) : (
    <EditAdditionalDetails
      selectedLabel={selectedLabel}
      setSelectedLabel={setSelectedLabel}
      label={label}
      att={packet[attr]}
      packet={packet}
      attr={attr}
      metaData={metaData}
      openCommmunicate={communicatePacket}
      cancelModel={cancelModel}
      closeComModal={closeComModal}
      saveHandler={saveHandler}
      indexingRows={indexingRows}
      context={context}
      controller={controller}
      appliedFilters={appliedFilters}
      data={editedDetails}
      setData={setEditedDetails}
      setIsObjectDirty={setIsObjectDirty}
      onClicktrackingCodeStatus={() => onClicktrackingCodeStatus(trackingCodeStatus, id)}
      LinkButton={LinkButton}
      takeComm={takeComm}
    />
  ));
};

function DetailRow({
  label, value, children, attr, editAccess, inputProps
}) {
  const {
    packet,
    isEditing,
    trackingCodeStatus,
    onClickPacketHistory
  } = inputProps;
  const {
    id
  } = packet;
  return (
    <li>
      <label htmlFor={`pcktbrsr-additionals-${attr}`}>{`${label}`}</label>
      <div className="form-layout-input">
        {isEditing && editAccess ? (
          <div className={getReqCls(attr)}>
            {getAdditionalDetailsEditCmp(inputProps, label, attr)}
            {getStatusCmp(attr, onClickPacketHistory)}
          </div>
        ) : (
          <>
            {packet[attr]}
            {getContactCmp(attr, packet)}
            {getTrackingCodeCmp(attr, trackingCodeStatus, id)}
            {getPacketHistory(attr, onClickPacketHistory)}
          </>
        )}
        {getValueCmps(value, children)}
      </div>
    </li>
  );
}

function AdditionalDetails({
  packet,
  context,
  metaData,
  indexingRows,
  isEditing,
  allowEditing,
  trackingCodeStatus,
  controller,
  appliedFilters,
  takeComm,
  setTakeComm,
  isChildEdit,
  setIsChildEdit,
  setPrevSelectedIndex,
  selectedIndex,
  ...props
}) {
  const {
    packetId, id, trackingBarCode, status, lockedBy
  } = packet;
  const [editedDetails, setEditedDetails] = useState({});
  const [isObjectDirty, setIsObjectDirty] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState(null);

  useEffect(() => {
    if (packetId != null) {
      setEditedDetails({ ...packet });
    }
  }, [packetId, lockedBy, packet]);

  let commentModal;

  const onClickPacketHistory = () => {
    bindLogger(
      props.getPacketStatusHistory,
      context
    )(packetId).subscribe(res => {
      openConfirmation({
        header: 'Packet Status History',
        isClose: true,
        renderComp: () => (
          <TrackingCodeStatus
            id={id}
            showTrackingCode={false}
            data={res.response}
            columns={packetStatusHistoryColumns}
          />
        )
      });
    });
  };

  const onCancelComment = () => {
    commentModal.handleClose();
  };

  const onClickSupportingDocs = () => {
    let dialog;
    const onClose = () => {
      if (dialog != null) {
        dialog.close();
      }
    };
    dialog = openConfirmation({
      header: 'Supporting Documents',
      isClose: false,
      renderComp: () => <SupportingDocs packet={packet} onClose={onClose} />
    });
  };

  const toggleEdit = () => {
    if (isEditing) {
      setEditedDetails({ ...packet });
      setSelectedLabel(null);
      props.toggleAdditionalDetails(false);
      setIsChildEdit(false);
    } else {
      setIsChildEdit(true);
      setPrevSelectedIndex(selectedIndex);
      // set the label to null only if its not take button action
      if (!takeComm) setSelectedLabel(null);
      props.toggleAdditionalDetails(true);
    }
  };

  const eventHistory = (packetIdVal, trackingBarCodeVal, statusVal, followup) => {
    const postdata = {
      followupReason: followup || null,
      status: statusVal || null,
      pktId: packetIdVal,
      trackingBarcode: trackingBarCodeVal
    };
    bindLogger(props.saveEventHistory, context)(editedDetails.packetId, postdata).subscribe(() => {
      bindLogger(props.getPacketCommunication, context)(editedDetails.packetId);
    });
  };

  const clearIndexingGrid = () => {
    deleteIndexing();
  };

  const saveAdditionalDetailsHandler = (additionalDetailsObj, followUp, modifiedIndexingData) => {
    bindLogger(props.saveAdditionalDetails, context)(additionalDetailsObj.id, additionalDetailsObj).subscribe(() => {
      props.toggleAdditionalDetails(false);

      showSuccessNotification(`${additionalDetailsObj.packetId} - Details saved successfully.`);
      if (isObjectDirty) {
        bindLogger(
          props.deleteIndexing,
          context
        )(editedDetails.packetId).subscribe(() => {
          if (isObjectDirty && modifiedIndexingData != null && modifiedIndexingData.length > 0) {
            bindLogger(props.updateIndexing, context)(
              editedDetails.packetId,
              editedDetails.object,
              modifiedIndexingData
            );
          } else if (isObjectDirty && (modifiedIndexingData == null || modifiedIndexingData.length === 0)) {
            bindLogger(props.getIndexing, context)(editedDetails.packetId, editedDetails.object);
          }
        });
      }

      if (status !== editedDetails.status) {
        eventHistory(editedDetails.packetId, editedDetails.trackingBarCode, editedDetails.status, followUp);
      }

      setIsObjectDirty(false);
      setIsChildEdit(false);
      controller.filterExternally(appliedFilters, false, false);
    });
  };

  const onSave = (contextType, commentVal, followUp) => {
    // create new indexing records data
    const modifiedIndexingData = setIndexingData(packet.object, editedDetails.object, clearIndexingGrid, indexingRows);
    const postdata = [];
    if (editedDetails.internalComments) {
      postdata.push({
        packetId: editedDetails.packetId,
        commentType: 'I',
        commentSource: 'RSS',
        comments: editedDetails.internalComments
      });
    }
    if (editedDetails.externalComments) {
      postdata.push({
        packetId: editedDetails.packetId,
        commentType: 'E',
        commentSource: 'RSS',
        comments: editedDetails.externalComments
      });
    }
    if (contextType === 'EMAIL' && commentVal) {
      postdata.push({
        packetId: editedDetails.packetId,
        commentType: 'E',
        commentSource: 'RSS',
        comments: commentVal
      });
    }
    if (contextType === 'PHONE' || contextType === 'NONE') {
      postdata.push({
        packetId: editedDetails.packetId,
        commentMethod: contextType,
        commentType: 'I',
        commentSource: 'RSS',
        comments: commentVal
      });
    }
    if (!_.isEmpty(postdata)) {
      bindLogger(props.saveComments, context)(editedDetails.packetId, postdata).subscribe(() => {
        delete editedDetails.internalComments;
        delete editedDetails.externalComments;
      });
    }
    delete editedDetails.internalComments;
    delete editedDetails.externalComments;
    if (editedDetails.status === 'COMPLETE' || editedDetails.status === 'VOID' || editedDetails.status === 'ARCHIVED') {
      const lockPostBody = {
        ...editedDetails,
        lockedBy: null
      };
      bindLogger(
        props.togglePacketLockBtn,
        context
      )(lockPostBody).subscribe(() => {
        showSuccessNotification(`Record Unlocked for ${packet.packetId}`);
      });
      saveAdditionalDetailsHandler(lockPostBody, followUp);
    } else {
      saveAdditionalDetailsHandler(editedDetails, followUp, modifiedIndexingData);
    }
    setTakeComm(false);
    setIsChildEdit(false);
  };

  const onSaveComment = (comment, saveRec, reason) => {
    if (_.isEmpty(comment)) {
      showErrorNotification(`Comment field cannot be empty.`);
      return;
    }
    if (!saveRec) {
      const postdata = [
        {
          packetId,
          commentType: 'E',
          commentSource: 'RSS',
          comments: comment
        }
      ];
      bindLogger(props.saveComments, context)(packetId, postdata).subscribe(() => {
        onCancelComment();
        eventHistory(editedDetails.packetId, editedDetails.trackingBarCode, editedDetails.status, reason);
      });
    } else {
      onCancelComment();
      onSave('EMAIL', comment, reason);
    }
  };

  const showCommentModal = (resp, saveRec, reason) => {
    commentModal = openConfirmation({
      header: 'External Comment',
      isClose: false,
      renderComp: () => (
        <ExternalComment
          saveRec={saveRec}
          onSaveComment={onSaveComment}
          onCancelComment={onCancelComment}
          text={resp.p_comment_out}
          followUp={!_.isEmpty(reason) && reason.value}
        />
      )
    });
  };

  // this function will handle cross btn on communication modal
  const cancelModel = (resp, saveRec, reason) => {
    setSelectedLabel(null);
    if (!_.isEmpty(resp)) {
      showCommentModal(resp, saveRec, reason);
    }
    setTakeComm(false);
  };

  // this function will handle cancel btn on communication modal
  const closeComModal = (...rest) => {
    modal.handleClose();
    cancelModel(...rest);
  };

  const saveHandler = (comment, selectedComOption, followupReason, showReason) => {
    setSelectedLabel(null);
    if (selectedComOption.toUpperCase() === 'PHONE' && comment === '') {
      return;
    }
    const comments = comment === '' ? ' ' : comment;

    const postdata = [
      {
        packetId,
        commentType: 'I',
        commentMethod: selectedComOption.toUpperCase(),
        commentSource: 'RSS',
        comments
      }
    ];
    if (showReason) {
      let reason = null;
      if (followupReason) {
        reason = followupReason.value;
      }
      onSave(selectedComOption.toUpperCase(), comments, reason);
    } else {
      bindLogger(props.saveComments, context)(packetId, postdata).subscribe(() => {
        eventHistory(editedDetails.packetId, editedDetails.trackingBarCode, editedDetails.status, '');
      });
    }
    controller.filterExternally(appliedFilters, false, false);
    modal.handleClose();
  };

  const onSaveValidation = (contextType, commentVal, followUp) => {
    setSelectedLabel(null);
    onSave(contextType, commentVal, followUp);
  };

  const copyClick = () => {
    bindLogger(
      props.copyPacket,
      context
    )(packetId).subscribe(res => {
      showSuccessNotification(`New packet ${res} created successfully.`);
      controller.filterExternally(
        {
          trackingBarCode
        },
        false,
        true
      );
      setTimeout(() => controller.sort({ name: 'id', order: 'desc' }), 1000);
      props.setSelectedindex(0);
    });
  };

  // if the take button is clicked in the parent grid then display the communicate popup
  useEffect(() => {
    if (takeComm && editedDetails && editedDetails.status) {
      setSelectedLabel('Packet Status');
    }
  }, [takeComm, editedDetails]);

  const inputProps = {
    packet,
    context,
    metaData,
    indexingRows,
    isEditing,
    allowEditing,
    trackingCodeStatus,
    controller,
    appliedFilters,
    takeComm,
    setTakeComm,
    isChildEdit,
    setIsChildEdit,
    setPrevSelectedIndex,
    selectedIndex,
    editedDetails,
    setEditedDetails,
    isObjectDirty,
    setIsObjectDirty,
    selectedLabel,
    setSelectedLabel,
    cancelModel,
    saveHandler,
    onSave,
    eventHistory,
    closeComModal,
    onClickPacketHistory,
    ...props
  };

  return (
    <div
      className={`form-layout-wrapper ${allowEditing && CanUserEditDetails() ? 'editable' : 'read-only'} ${isEditing
        && 'shadow-sm'}`}
    >
      <DetailsHeader
        isEditing={isEditing}
        supportingClick={onClickSupportingDocs}
        toggleEdit={toggleEdit}
        status={status}
        editedDetails={editedDetails}
        packet={packet}
        onSave={onSave}
        cancelModel={cancelModel}
        closeComModal={closeComModal}
        saveHandler={saveHandler}
        controller={controller}
        appliedFilters={appliedFilters}
        allowEditing={allowEditing}
        onClickCopy={copyClick}
        communicatePacket={communicatePacket}
      />
      <div className="form-layout-body">
        <div>{/* <span className="form-layout-required"></span> */}</div>
        <div className="form-sub-group">
          <DeatailsSubHeader id={id} title="Packet Details" />
          <ul className="mb-4">
            <RenderElement access={CanUserViewDetails()}>
              <DetailRow inputProps={inputProps} label="Object" attr="object" editAccess={CanUserEditDetails()} />
              <DetailRow inputProps={inputProps} label="Tracking Code" attr="trackingBarCode" editAccess={CanUserEditDetails()} />
              {isEditing && CanUserEditDetails() ? (
                <li>
                  <label htmlFor="pcktbrsr-additionals-content">Content</label>
                  <EditAdditionalDetails
                    selectedLabel={selectedLabel}
                    setSelectedLabel={setSelectedLabel}
                    label="Content"
                    attr="content"
                    metaData={metaData}
                    indexingRows={indexingRows}
                    context={context}
                    data={editedDetails}
                    setData={setEditedDetails}
                    setIsObjectDirty={setIsObjectDirty}
                    takeComm={takeComm}
                  />
                </li>
              ) : (
                <DetailRow inputProps={inputProps} label="Content" attr="content" />
              )}
            </RenderElement>
          </ul>
        </div>
        <div className="form-sub-group">
          <DeatailsSubHeader title="Contact Details" />
          <ul className="mb-4">
            <DetailRow inputProps={inputProps} label="Contact" attr="contact" editAccess={CanUserEditDetails()} />
            <DetailRow inputProps={inputProps} label="Email" attr="emailId" editAccess={CanUserEditDetails()} />
            <DetailRow inputProps={inputProps} label="Phone" attr="phone" editAccess={CanUserEditDetails()} />
            {isEditing ? (
              <li>
                <label htmlFor="pcktbrsr-additionals-otherContact">Other Contact</label>
                <EditAdditionalDetails
                  selectedLabel={selectedLabel}
                  setSelectedLabel={setSelectedLabel}
                  label="Other Contact"
                  attr="otherContact"
                  metaData={metaData}
                  indexingRows={indexingRows}
                  context={context}
                  data={editedDetails}
                  setData={setEditedDetails}
                  setIsObjectDirty={setIsObjectDirty}
                  takeComm={takeComm}
                />
              </li>
            ) : (
              <DetailRow inputProps={inputProps} label="Other Contact" attr="otherContact" />
            )}
          </ul>
        </div>
        <div className="form-sub-group">
          <DeatailsSubHeader title="Processing Information" />
          <ul className="mb-4">
            <DetailRow inputProps={inputProps} label="Priority" attr="priority" editAccess={CanUserEditDetails()} />
            <DetailRow inputProps={inputProps} label="Assigned To" attr="assignedTo" editAccess={CanUserEditDetails()} />
            <DetailRow inputProps={inputProps} label="Packet Status" attr="status" editAccess={CanUserEditDetails()} />
            <DetailRow inputProps={inputProps} label="Type" attr="packetType" editAccess={CanUserEditDetails()} />
            <DetailRow inputProps={inputProps} label="Packet Class" attr="packetClass" editAccess={CanUserEditDetails()} />
            {isEditing && CanUserEditPacketComments() ? (
              <li>
                <label htmlFor="pcktbrsr-additionals-internalComments">Internal Comments</label>
                <EditAdditionalDetails
                  selectedLabel={selectedLabel}
                  setSelectedLabel={setSelectedLabel}
                  label="Internal Comments"
                  attr="internalComments"
                  metaData={metaData}
                  indexingRows={indexingRows}
                  context={context}
                  data={editedDetails}
                  setData={setEditedDetails}
                  setIsObjectDirty={setIsObjectDirty}
                  takeComm={takeComm}
                />
              </li>
            ) : (
              <DetailRow inputProps={inputProps} label="Internal Comments" attr="internalComments" />
            )}
            {isEditing && CanUserEditPacketComments() ? (
              <li>
                <label htmlFor="pcktbrsr-additionals-externalComments">External Comments</label>
                <EditAdditionalDetails
                  selectedLabel={selectedLabel}
                  setSelectedLabel={setSelectedLabel}
                  label="External Comments"
                  attr="externalComments"
                  metaData={metaData}
                  indexingRows={indexingRows}
                  context={context}
                  data={editedDetails}
                  setData={setEditedDetails}
                  setIsObjectDirty={setIsObjectDirty}
                  takeComm={takeComm}
                />
              </li>
            ) : (
              <DetailRow inputProps={inputProps} label="External Comments" attr="externalComments" />
            )}
          </ul>
        </div>
        {isEditing && (
          <div className="align-right">
            <button
              data-id={`${ATC.PACKETID}${id}_SAVE${ATC.BUTTON}`}
              type="button"
              onClick={onSaveValidation}
              className="btn turquoise mx-1"
              title="Save"
            >
              Save
            </button>
          </div>
        )}
      </div>

      <PacketCommunication
        status={status}
        parentController={controller}
        appliedFilters={appliedFilters}
        packet={packet}
        additionalDetails={editedDetails}
      />
    </div>
  );
}
const mapStateToProps = state => ({
  indexingRows: state.packet.indexing,
  trackingCodeStatus: state.packet.trackingCodeStatus,
  isEditing: state.packet.additionalDetailsEdit
});

const withConnectState = connect(mapStateToProps, dispatch => bindActionCreators(
  {
    togglePacketLockBtn,
    getIndexing,
    getPacketStatusHistory,
    saveAdditionalDetails,
    saveComments,
    copyPacket,
    toggleAdditionalDetails,
    saveEventHistory,
    updateIndexing,
    deleteIndexing,
    getPacketCommunication
  },
  dispatch
));
export default withAppContext(withConnectState(AdditionalDetails));
